import React from "react";

export const Base = () => {
  return (
    <></>
    // <Store.Provider
    //   value={{
    //     baseUrl: "https://artemisapi.hr-flex.com/api/v1/clients",
    //     apiKey: "",
    //   }}
    // >
    //   <ErrorPage />
    // </Store.Provider>
  );
};

/**
 * TODO: Favicon, Page Name, Cover Include backIcon in Jobs
 * TODO: API Service */
